<script setup lang="ts">
import { useGlobalSearch } from "~/components/global-search/composables/useGlobalSearch";
import { useEnvironment } from "~/composables/useEnvironment";
import { useSidebar } from "~/composables/useSidebar";

const route = useRoute();
const router = useRouter();
const { showGlobalSearchModal, close } = useGlobalSearch();
const { isSidebarCollapsed, collapseSidebar, expandSidebar } = useSidebar();
const { isNotProduction } = useEnvironment();

router.beforeEach((to) => {
  if (to.meta.collapseSidebarOnEnter) {
    collapseSidebar();
  } else {
    expandSidebar();
  }
});

const isNavbarVisible = computed(() => !route.meta.hideNavbar && !isSidebarCollapsed.value);
</script>

<template>
  <div class="main">
    <NavBar v-if="isNavbarVisible" style="grid-area: navbar" />
    <div v-else class="w-3"></div>

    <div class="relative" style="grid-area: content; display: flex; overflow: hidden">
      <slot></slot>
      <LazyDevToolsImpersonationBanner v-if="isNotProduction" />
    </div>

    <EnvironmentProductionFrame />

    <LazyDevToolsIdentityModal v-if="isNotProduction" />

    <LazyGlobalSearchModal v-if="showGlobalSearchModal" @on-close="close()" />
  </div>
</template>

<style scoped lang="scss">
.main {
  display: grid;
  grid-template-areas: "navbar content";
  grid-template-columns: auto 1fr;
  height: 100dvh;
  width: 100dvw;
  background: var(--gray-8);
  overflow: hidden;
}
</style>
